import { WSElement, WSElementProps } from "@wingspanhq/fe-component-library";
import React from "react";
import styles from "./AmountText.module.scss";
import classNames from "classnames";

type Props = WSElementProps;

export const AmountText: React.FC<Props> = ({
  className,
  children,
  ...elementProps
}) => (
  <WSElement
    className={classNames(styles.amountText, className)}
    {...elementProps}
  >
    {children}
  </WSElement>
);
